module.exports = __webpack_public_path__ + "static/flowers-a46f7453d2be124911d08e92ae99b945.jpg";